import React from 'react';
import { motion } from 'framer-motion';
import './ProductFeature.css';

const ProductFeature = ({ image, title, description }) => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const fadeInLeft = {
    hidden: { opacity: 0, x: -60 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const fadeInRight = {
    hidden: { opacity: 0, x: 60 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="product-feature-section">
      <div className="product-feature-container">
        <motion.div 
          className="product-feature-img-box"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeInLeft}
        >
          <img src={image} alt={title} className="product-feature-img" />
        </motion.div>
        <motion.div 
          className="product-feature-content"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeInRight}
        >
          <motion.h2 
            className="product-feature-title"
            variants={fadeInUp}
          >
            {title}
          </motion.h2>
          <motion.p 
            className="product-feature-desc"
            variants={fadeInUp}
          >
            {description}
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProductFeature; 